import React from 'react';
import DawnLayout from './DawnLayout';
import SenseLayout from './SenseLayout';
import EmpireLayout from './EmpireLayout';
import BloomLayout from './BloomLayout';
import CircuitLayout from './CircuitLayout';
import SlateLayout from './SlateLayout';
import GroveLayout from './GroveLayout';
import TideLayout from './TideLayout';
import AuroraLayout from './AuroraLayout';
import SpiceLayout from './SpiceLayout';
import CleanLayout from './CleanLayout';
import EditorialLayout from './EditorialLayout';
import ArtisanLayout from './ArtisanLayout';
import ModernLayout from './ModernLayout';
import DarkLayout from './DarkLayout';
import CraftLayout from './CraftLayout';
import FreshLayout from './FreshLayout';
import PantryLayout from './PantryLayout';
import MidnightLayout from './MidnightLayout';
import MintLayout from './MintLayout';
import SolarLayout from './SolarLayout';
import LunarLayout from './LunarLayout';
import CoralLayout from './CoralLayout';
import ArcticLayout from './ArcticLayout';
import ElysianLayout from './ElysianLayout';
import AuraLayout from './AuraLayout';
import VeloraLayout from './VeloraLayout';
import OrbitLayout from './OrbitLayout';
import VogueLayout from './VogueLayout';
import RoyalCoutureLayout from './RoyalCoutureLayout';
import BrewAndBlendLayout from './BrewLayout';
import GoldenHarvestLayout from './BackeryLayout';
import FreshPantryLayout from './GroceryLayout';
import BloomFloraLayout from './BloomFloraLayout';
import LuxeSalonLayout from './LuxeSalonLayout';
import IronForgeLayout from './IronForgeLayout';
import AgriHarvestLayout from './AgriHarvestLayout';
import HardwareProLayout from './HardwareProLayout';
import StationeryProLayout from './StationeryProLayout';
import NexusLayout from './NexusLayout';
import AppleLayout from './AppleLayout';
import SamsungLayout from './SamsungLayout';
import LuxeGlowLayout from './LuxeGlowLayout';
import GlowAuraLayout from './GlowAuraLayout';
import FloraNectarLayout from './FloraNectarLayout';
import SilkyClayLayout from './SilkyClayLayout';
import VitalityLayout from './VitalityLayout';
import BreezeLayout from './BreezeLayout';
import UrbanLayout from './UrbanLayout';
import FarmFreshAgricultureLayout from './FarmFreshAgricultureLayout';
import EcoFarmAgricultureLayout from './EcoFarmAgricultureLayout';
import MediCarePharmacyLayout from './MediCarePharmacyLayout';
import MediCarePlusLayout from './MediCarePlusLayout';
import ApexManufacturingLayout from './ApexManufacturingLayout';
import EnchantedGiftEmporiumLayout from './EnchantedGiftEmporiumLayout';
import MobiTechLayout from './MobiTechLayout';
import PixelLayout from './PixelLayout';
import OnePlusLayout from './OnePlusLayout';
import VortexLayout from './VortexLayout';
import StudioNoirLayout from './StudioNoirLayout';
import CustomCraftLayout from './CustomCraftLayout';
export { getLayoutType, isDarkTheme } from './ThemeLayoutHelpers';


const LAYOUT_MAP = {
  dawn: DawnLayout,
  sense: SenseLayout,
  craft: CraftLayout,
  fresh: FreshLayout,
  pantry: PantryLayout,
  empire: EmpireLayout,
  bloom: BloomLayout,
  circuit: CircuitLayout,
  slate: SlateLayout,
  grove: GroveLayout,
  tide: TideLayout,
  aurora: AuroraLayout,
  spice: SpiceLayout,
  regal: EmpireLayout,
  meadow: GroveLayout,
  // legacy generic fallbacks
  clean: CleanLayout,
  editorial: EditorialLayout,
  artisan: ArtisanLayout,
  modern: ModernLayout,
  dark: DarkLayout,
    midnight: MidnightLayout,
  mint: MintLayout,
  lunar: LunarLayout,
  solar: SolarLayout,
  coral: CoralLayout,
  arctic: ArcticLayout,
  elysian: ElysianLayout,
  aura: AuraLayout,
  velora: VeloraLayout,
orbit: OrbitLayout,
vogue: VogueLayout,
royalcouture: RoyalCoutureLayout,
  brewblend: BrewAndBlendLayout,
  goldenharvest: GoldenHarvestLayout,
  freshpantry: FreshPantryLayout,
  bloomflora: BloomFloraLayout,
  luxesalon: LuxeSalonLayout,
ironforge: IronForgeLayout,
agriharvest: AgriHarvestLayout,
  hardwarepro: HardwareProLayout,
  stationerypro: StationeryProLayout,
  nexus: NexusLayout,
  quantum: SlateLayout,
  apple: AppleLayout,
  samsung: SamsungLayout,
  luxeglow: LuxeGlowLayout,
  glowaura: GlowAuraLayout,
  floranectar: FloraNectarLayout,
  silkyclay: SilkyClayLayout,
  vitality: VitalityLayout,
  breeze: BreezeLayout,
  urban: UrbanLayout,
  ecofarm: EcoFarmAgricultureLayout,
  farmfresh: FarmFreshAgricultureLayout,
  medicare: MediCarePharmacyLayout,
  medicareplus: MediCarePlusLayout,
   apexmanufacturing: ApexManufacturingLayout,
   enchantedgifts: EnchantedGiftEmporiumLayout,
  mobitech: MobiTechLayout,
  pixel: PixelLayout,
  oneplus: OnePlusLayout,
  vortex: VortexLayout,
  studionoir: StudioNoirLayout,
  custom: CustomCraftLayout,
};

export function ThemeLayoutContent({ layoutType, layoutProps }) {
  const Layout = LAYOUT_MAP[layoutType] || DawnLayout;
  return <Layout p={layoutProps} />;
}
